var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGovernment175(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.68,47.48V26.05S115,31,126.24,26V36.77s-7.87,5.78-18.21,0m5.35,80.06a6.47,6.47,0,1,1-6.47-6.55A6.5,6.5,0,0,1,113.38,116.83Zm40.72,39.81h14.36m-45,0h14.37m-61.21,0H91m-45,0H60.42m92.86,36.88v-37l-5.08-9.73h-5.37l-4.95,9.73v37m-92,0,0-37-5.07-9.74H35.41l-5,9.74v37l153.43-.06v-37l-5.08-9.73h-5.36l-5,9.73,0,37m-92.64,0,0-37-5.08-9.73H65.39l-5,9.73v37.05M99.53,84.23V71.44l7.34-24,7.63,24L114,85M91.62,193.57l0-105.82,5-5.53,5.3,5.52v9h9.88v-9l5.3-5.52,5,5.52,0,105.82"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernment175);
export default __webpack_public_path__ + "static/media/GOVERNMENT_175.b5141c2c83fb0ff7fb5a73d6da41fa69.svg";
export { ForwardRef as ReactComponent };